import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ModuleService } from '../../service/service';
import { Toast } from 'src/shared/components/toast';
export function useUpdateModuleMutation(moduleId) {
    const { t } = useTranslation();
    return useMutation({
        mutationFn: (payload) => {
            return ModuleService.updateModule(moduleId, payload);
        },
        onSuccess: () => {
            Toast.show({ type: 'success', message: t('modules.toast.edit.sucess') });
        },
        onError: () => {
            Toast.show({ type: 'danger', message: t('modules.toast.edit.error') });
        }
    });
}
